import { jsxs, jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../theme/ThemedComponentWrapper.js';
import 'luxon';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../icons/InfinityIcon.js';
import '../../icons/ArrowUpRightBoxIcon.js';
import '../CurrencyValue/components/Value.js';
import '../KpiCard/KpiCard.js';
import '../PercentageValue.js';
import '../Tabs/Tabs.js';
import '../TrendValue.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../Modal/Modal.js';
import '@floating-ui/react';
import '../../charts/ChartKpis/ChartKpi.js';
import '../../charts/ChartJS.js';
import '../../charts/Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';
import 'ethereum-blockies-base64';
import Box from '../../atoms/layout/Box/Box.js';
import '../../atoms/layout/Stack/Stack.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/Table/Table.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Tooltip/components/TooltipContext.js';

function CollapsableSidebar({ sidebarOpen, toggleSidebar, children, ...rest }) {
    return (jsxs(Fragment, { children: [jsx(ThemedComponentWrapper, { flexDirection: "column", as: "aside", variant: !sidebarOpen ? 'closed' : undefined, ...rest, name: "collapsableSidebar", children: children }), sidebarOpen ? (jsx(Box, { onClick: () => toggleSidebar(), name: "alphaBackgroundLayer" })) : null] }));
}

export { CollapsableSidebar as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
